import moment from 'moment';

import { GetUserActionType } from '../../global-actions/types';
import { TogglesState } from '../../toggles';

const reducers = {
  getUser: (app, registrationToken: GetUserActionType['payload']) => ({
    ...app,
    registeredUser: {
      ...app.registeredUser,
      token: registrationToken
    }
  }),

  userGetUserSuccess: (
    userStore,
    payload: { user: any; config: any; preregisteredUser: any }
  ) => {
    return {
      ...userStore,
      tempPhoneNumber: payload.user.phoneNumber,
      registeredUser: {
        ...payload,
        token: userStore.registeredUser?.token
      },
      preregisteredUser: payload.preregisteredUser,
      role: payload.preregisteredUser
        ? payload.preregisteredUser.role
        : userStore.role,
      isParentInvitedByChild:
        payload.preregisteredUser &&
        payload.preregisteredUser.role === 'parent',
      isChildInvitedByParent:
        payload.preregisteredUser && payload.preregisteredUser.role === 'child'
    };
  },

  userQueryGetUserSuccess: (userStore, payload: { user: any }) => {
    let nextRegStep: string = payload.user.nextRegisterStep;
    if (
      payload.user.nextRegisterStep === 'complete' &&
      payload.user.role === 'child'
    ) {
      nextRegStep = 'complete_child';
    }

    return {
      ...userStore,
      tempPhoneNumber: payload.user.phoneNumber,
      nextRegStep,
      registeredUser: {
        ...payload.user
      }
    };
  },

  setDeviceUUID: (userStore, deviceUUID: string) => ({
    ...userStore,
    deviceToken: deviceUUID
  }),

  setPreregisteredUser: (userStore, preregisteredUser: any) => ({
    ...userStore,
    preregisteredUser
  }),

  setChildDateOfBirth: (
    userStore,
    { dob, toggles }: { dob: string; toggles: TogglesState }
  ) => {
    const age = moment().diff(moment(dob, 'MM/DD/YYYY'), 'years');

    if (userStore.preregisteredUser)
      return {
        ...userStore,
        dob,
        nextRegStep: 'register'
      };

    if (
      toggles.kidFirstRegParentInviteV0.enabled ||
      toggles.kidFirstRegParentInviteV1.enabled
    ) {
      return {
        ...userStore,
        dob,
        nextRegStep: 'parent_invite',
        needsAccessRequest: age >= 13
      };
    }

    return {
      ...userStore,
      dob,
      nextRegStep: age >= 13 ? 'validate' : 'cancel_age',
      needsAccessRequest: age >= 13
    };
  },

  setRole: (userStore, role: string) => {
    let nextRegStep;
    if (role === 'parent') nextRegStep = 'validate';
    if (role === 'child') nextRegStep = 'complete_placeholder';

    return {
      ...userStore,
      role,
      needsAccessRequest: role === 'parent',
      nextRegStep
    };
  },

  setUrlRole: (userStore, urlRole: string) => {
    return {
      ...userStore,
      urlRole
    };
  },

  setPartnerParams: (
    userStore,
    payload: {
      partner: string;
      phoneNumber: string;
      firstName: string;
      promotionId: string;
    }
  ) => ({
    ...userStore,
    partner: payload.partner,
    phoneNumber: payload.phoneNumber,
    firstName: payload.firstName,
    promotionId: payload.promotionId
  }),

  setPartner: (userStore, payload: { partner: string }) => ({
    ...userStore,
    partner: payload.partner
  }),

  setPhoneNumberProvided: userStore => ({
    ...userStore,
    phoneNumberProvided: true
  }),

  setUrlEmail: (userStore, payload: { urlEmail: string }) => ({
    ...userStore,
    urlEmail: payload.urlEmail
  }),

  clearRegisteredUser: userStore => ({
    ...userStore,
    preregisteredUser: null
  }),

  setFirstName: (userStore, firstName) => ({
    ...userStore,
    firstName
  }),

  setIpAddress: (userStore, ipAddress: string) => ({
    ...userStore,
    ipAddress
  }),

  setPromotionId: (userStore, promotionId) => ({
    ...userStore,
    promotionId
  }),

  setApproverInviteProperties: (
    userStore,
    payload: { phoneNumber: string; placeholderToken: string }
  ) => ({
    ...userStore,
    tempPhoneNumber: payload.phoneNumber,
    placeholderToken: payload.placeholderToken
  }),

  setTempPhoneNumber: (userStore, phoneNumber: string) => ({
    ...userStore,
    tempPhoneNumber: phoneNumber
  }),

  setNextRegStep: (userStore, nextRegStep: string) => ({
    ...userStore,
    nextRegStep
  }),

  setAdvocateIsTeen: (userStore, advocateIsTeen: string) => ({
    ...userStore,
    advocateIsTeen
  }),

  setUserIsTeen: (userStore, userIsTeen: boolean) => ({
    ...userStore,
    userIsTeen
  }),

  setInAppUserPropertiesOnAnswer: (
    userStore,
    payload: { questions: Array<string>; answers: Array<string>; token: string }
  ) => userStore
};

export default { ...reducers };
